import ServiceHeader from '../../ServiceComponents/ServiceHeader';
export default function CheckOutBanner() {
    return (
        <>
            <ServiceHeader
                childClass="CheckOutBanner"
                breadcrumb={<> Check Out</>}
                title="Check Out"
            />
        </>
    );
}